export default __webpack_public_path__ + "static/itreview-banner-pc-115c1ef832e625700442e161b23dc989.png";